import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Youtube, Mail, Phone, MapPin, Clock, Building2 } from 'lucide-react';
import { CONTACT, COMPANY } from '../mock';

const Footer = () => {
  return (
    <footer className="footer-bg pt-20">
      <div className="max-w-[1280px] mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="mid-logo-mark">M</span>
            <span className="font-serif-display text-2xl font-bold text-white">Midbrothers</span>
          </div>
          <p className="text-[#9fb2c8] text-sm leading-relaxed mb-5">
            Leading financial technology solutions provider offering consulting, investment, and startup coaching
            services worldwide for over 15 years.
          </p>
          <div className="flex gap-2">
            {[Facebook, Twitter, Linkedin, Instagram, Youtube].map((Ico, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full border border-white/20 text-white flex items-center justify-center hover:bg-[#0a6cb0] hover:border-[#0a6cb0] transition-colors">
                <Ico size={15} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-5 tracking-wider">SERVICES</h4>
          <ul className="space-y-3 text-[#9fb2c8] text-sm">
            {['Financial Consulting','Investment','Book Publishing','IT Consulting','Target Marketing'].map(s => (
              <li key={s}><a href="/#services" className="hover:text-white transition-colors">{s}</a></li>
            ))}
            <li><Link to="/retirement" className="hover:text-white transition-colors">Retirement Planning</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-5 tracking-wider">CONTACT</h4>
          <ul className="space-y-3 text-[#9fb2c8] text-sm">
            <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-[#0a6cb0] shrink-0" /><span>{CONTACT.email}</span></li>
            <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-[#0a6cb0] shrink-0" /><span>{CONTACT.phone}</span></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[#0a6cb0] shrink-0" /><span>{CONTACT.address}</span></li>
            <li className="flex items-start gap-3 pt-3 border-t border-white/10">
              <Building2 size={16} className="mt-0.5 text-[#0a6cb0] shrink-0" />
              <div>
                <p className="text-white text-xs uppercase tracking-wider font-semibold mb-1">Registered Office</p>
                <p>{COMPANY.registeredOffice}</p>
              </div>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-5 tracking-wider">QUICK LINKS</h4>
          <ul className="space-y-3 text-[#9fb2c8] text-sm mb-5">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/our-builds" className="hover:text-white transition-colors">Our Builds</Link></li>
            <li><Link to="/retirement" className="hover:text-white transition-colors">Retirement Planning</Link></li>
            <li><a href="/#contact" className="hover:text-white transition-colors">Contact Us</a></li>
          </ul>
          <div className="flex items-start gap-3 pt-4 border-t border-white/10 text-[#9fb2c8] text-sm">
            <Clock size={16} className="mt-0.5 text-[#0a6cb0] shrink-0" />
            <div>
              <p className="text-white font-semibold text-xs uppercase tracking-wider mb-1">Working Hours</p>
              <p>{CONTACT.hours}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1280px] mx-auto px-6 py-6 mt-14 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-[#9fb2c8]">
        <p>&copy; {new Date().getFullYear()} Midbrothers. All rights reserved. &middot; Company Reg. No. <span className="text-white/80">{COMPANY.registrationNumber}</span></p>
        <div className="flex gap-6">
          <a href="#" className="hover:text-white">Privacy Policy</a>
          <a href="#" className="hover:text-white">Terms of Service</a>
          <a href="#" className="hover:text-white">Cookies</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
